export type Locale = 'en' | 'es';

export const LOCALES: Locale[] = ['en', 'es'];
export const DEFAULT_LOCALE: Locale = 'en';
export const LOCALE_STORAGE_KEY = 'my-budget-locale';

export type LandingMessages = {
  brand: string;
  navAria: string;
  signIn: string;
  headline: string;
  supporting: string;
  standaloneHeadline: string;
  standaloneSupporting: string;
  startFree: string;
  seeHow: string;
  pricingNote: string;
  sessionExpired: string;
  problemLabel: string;
  problemTitle: string;
  problemBody: string;
  howLabel: string;
  howTitle: string;
  howLead: string;
  step1Title: string;
  step1Body: string;
  step2Title: string;
  step2Body: string;
  step3Title: string;
  step3Body: string;
  featuresLabel: string;
  featuresTitle: string;
  featureControlTitle: string;
  featureControlBody: string;
  featureOverrunTitle: string;
  featureOverrunBody: string;
  featureVisualTitle: string;
  featureVisualBody: string;
  featurePlanningTitle: string;
  featurePlanningBody: string;
  featureGoalsTitle: string;
  featureGoalsBody: string;
  abstractCategoryA: string;
  abstractCategoryB: string;
  abstractUsed: string;
  abstractNearLimit: string;
  finalLabel: string;
  finalTitle: string;
  finalLead: string;
  apiKeysLabel: string;
  apiKeysTitle: string;
  apiKeysLead: string;
  apiKeysCta: string;
  installLabel: string;
  installTitle: string;
  installLead: string;
  installStep1Title: string;
  installStep1Body: string;
  installStep2Title: string;
  installStep2Body: string;
  installStep3Title: string;
  installStep3Body: string;
  installAndroidNote: string;
  footer: string;
  languageAria: string;
  langEn: string;
  langEs: string;
  documentTitle: string;
};
